import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ecee6e68&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecee6e68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecee6e68')) {
      api.createRecord('ecee6e68', component.options)
    } else {
      api.reload('ecee6e68', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ecee6e68&scoped=true&", function () {
      api.rerender('ecee6e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8KB4MFKRMApW9/JS/comp/Accordion.vue"
export default component.exports